export class ConditionMedia {
  deviceIds: Array<Number>;
  playlistIds: Array<Number>;
  mediaTypes: Array<string>;
  fileName: string;
  constructor() {}
}
